import React from 'react';
import { Link } from 'react-router-dom';
import LogoAlone from '../../assets/LogoforDarkBackground.png';

const Banner = ({ t }) => {
    return (
        <div id="home" className="jarallax">
            {/*<Link to="/" className="navbar-brand">
                <img src={require('../../assets/LogoforLightBackground.png')} alt="logo" />
            </Link>*/}
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container-fluid">
                        <div className="main-banner-content">
                            {/* <span className="sub-title">{t("banner.subtitle")}</span>
                            <h1>{t("banner.title")}</h1> */
                            //<img className="banner-image" alt="Banner" src={LogoAlone}></img>
                            }
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="banner-footer-content">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-sm-6">
                            <span className="email-link">info@geniusballsports.com</span>
                        </div>

                        <div className="col-lg-6 col-sm-6">
                            <ul className="social">
                                <li>
                                    <Link to="https://www.facebook.com/" target="_blank">
                                        <i className="flaticon-facebook"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://twitter.com/" target="_blank">
                                        <i className="flaticon-twitter-1"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank">
                                        <i className="flaticon-instagram-1"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://www.linkedin.com/" target="_blank">
                                        <i className="flaticon-linkedin-1"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://www.youtube.com/channel/UC3LeTV-zd6sGSvSayUF2E7g" target="_blank">
                                        <i className="flaticon-youtube-1"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div >
                    </div >
                </div >
            </div > */}
        </div>
    );
};

export default Banner;
